<template>
    <div class="apprentice-simple-card group-assignments-accesses">
        <design-2021-apprentice-data-table
            class="group-show-students-table"
            v-if="items && items.length"
            :fields="fields"
            :items="items"
            :download-excel-settings="downloadExcelSettings"
            :sort-compare="sortCompare">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-assignment"
                    v-if="groupIn.permissions.coordinator"
                    v-b-modal="'add-project-modal'"
                    v-b-tooltip.hover
                    :title="addProjectString"
                    variant="primary-icon"
                    ><!-- //&& groupIn.type_id !== 6 -->
                </b-button>

                <b-button
                    class="btn-users btn-group-pair"
                    v-if="groupIn.group_pair_options"
                    v-b-tooltip.hover
                    :title="$t('group.groups_active')"
                    variant="primary-icon"
                    @click="showGroupPair">
                </b-button>

                <b-dropdown
                    class="ellipsis-nav bordered-menu group-assignment-edit-nav"
                    v-if="groupIn.type_id !== 6"
                    no-caret
                    right
                    text="Right align"
                    toggle-class="group-assignment-edit-context-menu"
                    variant="primary">
                    <template #button-content>
                        <i class="fas fa-fw fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                        class="edit-group"
                        v-if="groupIn.permissions.coordinator"
                        @click.prevent.stop="showGroupAssignmentEditAddModal">
                        <!-- && groupIn.type_id !== 6-->
                        <i class="btn-add"></i>{{ addProjectString }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        class="lock-group"
                        v-if="isAdmin"
                        @click.prevent.stop="importList">
                        <i class="btn-upload"></i>{{ $t('group.import_list') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        class="open-group"
                        @click.prevent.stop="download()">
                        <i class="btn-download"></i>{{ $t('group.download_list') }}
                    </b-dropdown-item>
                </b-dropdown>
            </template>

            <template v-slot:cell(title)="data">
                <div class="title-wrapper">
                    {{ data.item.title }}
                </div>
            </template>

            <template v-slot:cell(name)="data">
                <div class="student-names-wrapper">
                    <div
                        class="student-name"
                        v-for="name of studentNames(data.item.name)">
                        {{ name }}
                    </div>
                </div>
            </template>

            <template v-slot:cell(surname)="data">
                <div class="student-surnames-wrapper">
                    <div
                        class="student-surname"
                        v-for="surname of studentNames(data.item.surname)">
                        {{ surname }}
                    </div>
                </div>
            </template>

            <template
                v-if="groupIn.type_id === 6"
                v-slot:cell(internship)="data">
                <div
                    class="internship-wrapper"
                    v-if="data.item.internship && data.item.internship.pivot.status !== 0">
                    <div class="internship">
                        {{ data.item.internship.name }}
                    </div>
                </div>
            </template>

            <template
                v-if="groupIn.type_id === 6"
                #cell(organization)="data">
                <div
                    class="organization"
                    v-if="data.item.internship && data.item.internship.pivot.status !== 0">
                    {{ data.item.internship.organization }}
                </div>
            </template>

            <template
                v-if="groupIn.type_id === 6"
                #cell(location)="data">
                <div
                    class="location"
                    v-if="data.item.internship && data.item.internship.pivot.status !== 0">
                    {{ data.item.internship.location }}
                </div>
            </template>

            <template
                v-if="groupIn.type_id === 6"
                v-slot:cell(acceptance)="data">
                <div
                    class="acceptance-wrapper"
                    v-if="data.item.internship && data.item.internship.pivot.status !== 0">
                    <div class="acceptance">
                        <div
                            class="internship-accepted"
                            v-if="data.item.internship.pivot.status === 2">
                            <i
                                class="icon fas fa-check"
                                v-b-tooltip.hover
                                :title="$t('group.approved')">
                            </i>
                        </div>

                        <div
                            class="internship-pending"
                            v-else-if="data.item.internship.pivot.status === 1">
                            <b-button
                                class="btn-duo-hourglass-half btn-view-invite"
                                v-b-tooltip.hover
                                :title="$t('group.view_internship_and_motivation')"
                                variant="warning-icon-only"
                                @click="showInternshipMotivationModal(data.item.internship)">
                            </b-button>
                        </div>
                    </div>
                </div>
            </template>

            <template
                v-if="groupIn.type_id === 6"
                v-slot:cell(internship_agreement)="data">
                <div
                    class="internship-agreement"
                    v-if="data.item.internship_agreements.length">
                    <a
                        v-for="agreement in data.item.internship_agreements"
                        :href="agreement.file.path"
                        target="_blank">
                        {{ agreement.file.full_name }}
                    </a>
                </div>
            </template>

            <template v-slot:cell(teachers)="data">
                <div class="teacher-wrapper">
                    <div
                        class="teacher"
                        v-for="teacher of teacherNames(data.item.teachers)">
                        {{ teacher }}
                    </div>
                </div>
            </template>

            <template v-slot:cell(messages)="data">
                <div
                    class="unread-messages"
                    v-if="data.item.messages_count && data.item.messages_count !== 0">
                    <b-button
                        class="btn-group-student-messages-notification"
                        variant="primary-icon-only"
                        @click="showMessageModal(data.item.id)">
                        <span class="btn-closed-envelope"></span>
                        <span class="notification-bubble group-messages-count messages-count-bubble">
                            {{ data.item.messages_count }}
                        </span>
                    </b-button>
                </div>
                <div
                    class="messages"
                    v-else>
                    <b-button
                        class="btn-opened-envelope btn-group-student-messages"
                        variant="primary-icon-only"
                        @click="showMessageModal(data.item.id)">
                    </b-button>
                </div>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="management-actions">
                    <b-button
                        class="btn-open btn-open-assignment"
                        :v-b-tooltip="$t('group.open_assignment')"
                        :href="viewRoute(data.item)"
                        variant="primary-icon-only">
                    </b-button>

                    <b-button
                        class="btn-edit btn-edit-internship"
                        v-if="data.item.internship && data.item.internship.pivot.status !== 0"
                        :v-b-tooltip="$t('group.edit_internship')"
                        variant="primary-icon-only"
                        @click="showUpdateInternshipModal(data.item.internship)">
                    </b-button>

                    <b-button
                        class="btn-recycle btn-reset-internship"
                        v-if="data.item.internship && data.item.internship.pivot.status === 2"
                        :v-b-tooltip="$t('group.edit_internship_status')"
                        variant="primary-icon-only"
                        @click="statusUpdate(data.item.internship)">
                    </b-button>

                    <b-button
                        class="btn-history btn-internship-logs"
                        v-if="data.item.internship_project !== undefined && data.item.internship_project"
                        v-b-tooltip="'Stage status Logs'"
                        variant="primary-icon-only"
                        @click="showInternshipProjectLogs(data.item.internship_project)">
                    </b-button>

                    <b-button
                        class="btn-remove btn-remove-assignment"
                        v-if="groupIn.permissions.coordinator"
                        :v-b-tooltip="$t('group.delete_paper_confirmation_title')"
                        variant="danger-icon-only"
                        @click="removeItem(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header empty-assignments-list"
            v-else>
            <div class="header">
                <b-button
                    class="btn-upload btn-assignment-import-list"
                    v-if="isAdmin"
                    variant="primary"
                    @click="importList">
                    {{ $t('group.import_list') }}
                </b-button>
                <b-button
                    class="btn-add btn-add-assignment"
                    v-if="groupIn.permissions.coordinator"
                    v-b-modal="'add-project-modal'"
                    variant="primary">
                    {{ addProjectString }}
                </b-button>
            </div>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('group.no_papers_been_created') }}</div>
        </div>

        <design-2021-group-show-export-download-modal-component
            :groupId="groupIn.id"></design-2021-group-show-export-download-modal-component>
        <design-2021-group-show-add-project-modal-component
            v-if="groupIn.permissions.coordinator"
            ref="add-project-modal"
            :group-in="groupIn"
            :has-children="false"
            @project-added="addItem($event)">
        </design-2021-group-show-add-project-modal-component>
        <design-2021-group-show-project-message-modal-component
            ref="project-message-modal"></design-2021-group-show-project-message-modal-component>
        <design-2021-group-show-internship-motivation-modal-component
            ref="internship-motivation-modal"
            :google-map-api="googleMapApi"
            @accepted="updateProjects($event)"
            @rejected="updateProjects($event)">
        </design-2021-group-show-internship-motivation-modal-component>

        <design-2021-group-show-change-internship-modal-component
            ref="updateInternshipModal"
            :internships-in="internships"
            @updated-internship="storeUpdatedInternship">
        </design-2021-group-show-change-internship-modal-component>

        <design-2021-group-show-reject-internship-modal-component
            ref="rejectInternshipModal"
            @rejected="updateProjects">
        </design-2021-group-show-reject-internship-modal-component>

        <design-2021-group-show-internship-status-logs-modal-component ref="internshipProjectLogs">
        </design-2021-group-show-internship-status-logs-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-assignment-edit-component',
    props: ['groupIn', 'studentPerProjects', 'projectsIn', 'isStudent', 'googleMapApi', 'internshipsIn'],
    data() {
        return {
            projects: this.projectsIn,
            searchedTerm: null,
            currentPage: 1,
            perPage: 10,
            isAdmin: !!AuthIsAdmin,
            internships: this.internshipsIn,
            updateComputeds: 0,
        };
    },

    methods: {
        updateProjects(updatedProject) {
            this.updateComputeds = this.updateComputeds++;
            this.projects = this.projects.map((project) => {
                if (project.id === updatedProject.id) {
                    project.internship = updatedProject.internship;
                    project.internship_project = updatedProject.internship_project;
                    return project;
                }
                return project;
            });
        },

        studentNames(students) {
            return students.split('\r\n');
        },

        teacherNames(teachers) {
            return teachers.split(', ');
        },

        showMessageModal(project_id) {
            this.$refs['project-message-modal'].show(project_id);
            this.resetFrontEndMessages(project_id);
        },

        importList() {
            window.location.href = this.routes.groupShow(this.groupIn.id) + '/import';
        },

        removeItem(id) {
            this.alert
                .confirm(
                    this.$t('group.delete_paper_confirmation_title'),
                    this.$t('group.delete_paper_confirmation_body'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(this.routes.projectDelete(id)).then(
                            (response) => {
                                this.projects = this.projects.filter((item) => item.id !== id);
                                this.items = this.items.filter((item) => item.id !== id);
                                this.$emit('items-changed', this.items);
                                this.$refs['add-project-modal'].clearLoadedUsers();
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        addItem(values) {
            const data = {
                name: values.name,
                groupId: this.groupIn.id,
                user_ids: values.user_ids,
            };

            this.alert.saving(this.$t('group.add_paper'));
            this.axios.post(this.routes.project(), data).then(
                (response) => {
                    let student_names = [];
                    let teacher_names = [];

                    for (const student of response.data.students) {
                        student_names.push(student.full_name);
                    }
                    for (const teacher of response.data.teachers) {
                        teacher_names.push({ name: teacher.full_name, id: teacher.id });
                    }
                    let data = {
                        id: response.data.id,
                        last:
                            response.data.last_edited === '-'
                                ? response.data.last_edited
                                : this.$options.filters.date_time_om_year(response.data.last_edited),
                        logbook: response.data.logbook_hours,
                        messages: response.data.messages,
                        students: student_names.join(', '),
                        teachers: teacher_names,
                        title: response.data.title,
                        words: response.data.words,
                        closes_at: response.data.closes_at,
                    };

                    this.items.push(data);
                    this.projects.push(response.data);

                    this.$emit('items-changed', this.items);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        download() {
            this.$bvModal.show('group-export-download-modal');
        },

        resetFrontEndMessages(project_id) {
            this.items = this.items.map((item) => {
                if (item.id === project_id) {
                    this.$emit('reset-total-messages-count', item.messages_count);
                    item.messages_count = 0;
                }
                return item;
            });
        },

        viewRoute(item) {
            switch (this.groupIn.type_id) {
                case 1:
                case 5:
                    return this.routes.paperShow(item.id);
                case 2:
                    return this.routes.portfolioShow(item.id);
                case 4:
                    return this.routes.paperShow(item.id);
                case 6:
                    return this.routes.projectInternshipShow(item.id);
                case 7:
                    return this.routes.creathlonShow(item.id);
            }
        },

        showGroupAssignmentEditAddModal() {
            this.$refs['add-project-modal'].$refs['add-project-modal'].show();
        },

        showGroupPair() {
            window.location.href = this.routes.groupShowGroupPair(this.groupIn.id);
        },

        showInternshipMotivationModal(internship) {
            this.$refs['internship-motivation-modal'].show(internship);
        },

        sortCompare(firstRow, secondRow, key) {
            if (this.groupIn.type_id === 6) {
                const $primaryRow = this.items.find((item) => item.id === firstRow.id);
                const $secondaryRow = this.items.find((item) => item.id === secondRow.id);

                switch (key) {
                    case 'acceptance':
                        const $firstRowValue =
                            ($primaryRow.internship && $primaryRow.internship.pivot.status) !== null
                                ? $primaryRow.internship && $primaryRow.internship.pivot.status
                                : 1;
                        const $secondRowValue =
                            ($secondaryRow.internship && $secondaryRow.internship.pivot.status) !== null
                                ? $secondaryRow.internship && $secondaryRow.internship.pivot.status
                                : 1;

                        if ($firstRowValue > $secondRowValue) {
                            return 1;
                        }
                        if ($firstRowValue < $secondRowValue) {
                            return -1;
                        }
                        return 0;
                        break;

                    case 'internship_agreement':
                        const $agreementFirstRowValue =
                            $primaryRow.internship && $primaryRow.internship.agreements ? 1 : 0;
                        const $agreementSecondRowValue =
                            $secondaryRow.internship && $secondaryRow.internship.agreements ? 1 : 0;

                        if ($agreementFirstRowValue > $agreementSecondRowValue) {
                            return 1;
                        }
                        if ($agreementFirstRowValue < $agreementSecondRowValue) {
                            return -1;
                        }
                        return 0;
                        break;
                }
            }
        },

        showUpdateInternshipModal(internship) {
            this.$refs.updateInternshipModal.show(internship);
        },

        statusUpdate(internship) {
            this.alert
                .confirm(
                    this.$t('group.reopen_internship_confirmation_title'),
                    this.$t('group.reopen_internship_confirmation_body'),
                    this.$t('common.yes_reopen'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.close();
                    this.$refs.rejectInternshipModal.show(internship);
                });
        },

        storeUpdatedInternship(internshipdata) {
            const data = {
                internship_id: internshipdata.internshipId,
                project_id: internshipdata.projectId,
                group_id: this.groupIn.id,
                feedback: internshipdata.feedback,
            };

            this.alert.saving();
            this.axios.post(this.routes.updateinternship(internshipdata.initialInternshipId), data).then(
                (response) => {
                    this.updateProjects(response.data);
                    this.alert.success();
                },

                (error) => {
                    this.alert.error(error);
                },
            );
        },

        showInternshipProjectLogs(logs) {
            this.$refs.internshipProjectLogs.show(logs);
        },
    },

    computed: {
        addProjectString() {
            switch (this.groupIn.type_id) {
                case 1:
                    return this.$t('assignment.new_project');
                case 2:
                    return this.$t('assignment.add_student');
                case 3:
                    return this.$t('assignment.add_student');
                case 4:
                    return this.$t('assignment.add_magazine');
                case 5:
                    return this.$t('assignment.add_student');
                case 6:
                    return this.$t('assignment.add_student');
                default:
                    return this.$t('assignment.add_student');
            }
        },
        searchedItems() {
            if (this.searchedTerm === null || this.searchedTerm == '') return this.items;
            return this.items.filter((item) => {
                this.searchedTerm = this.searchedTerm.toLowerCase();
                if (
                    item.students.name.toLowerCase().indexOf(this.searchedTerm) > -1 ||
                    item.teachers.name.toLowerCase().indexOf(this.searchedTerm) > -1 ||
                    item.title.toLowerCase().indexOf(this.searchedTerm) > -1
                ) {
                    return item;
                }
            });
        },
        filesRows() {
            if (this.searchedItems) return this.searchedItems.length;
        },

        fields() {
            let array = [];

            if (this.groupIn.type_id !== 2 && this.groupIn.type_id !== 6) {
                array.push({
                    key: 'title',
                    label: this.$t('common.title'),
                    sortable: true,
                });
            }

            array.push(
                {
                    key: 'name',
                    label: this.$t('common.first_name'),
                    sortable: true,
                },
                {
                    key: 'surname',
                    label: this.$t('common.last_name'),
                    sortable: true,
                },
            );

            if (this.groupIn.type_id === 6) {
                array.push(
                    {
                        key: 'internship',
                        label: this.$t('group.internship'),
                    },
                    {
                        key: 'organization',
                        label: this.$t('common.organization'),
                    },
                    {
                        key: 'location',
                        label: this.$t('common.city'),
                        sortable: true,
                    },
                    {
                        key: 'acceptance',
                        label: this.$t('group.acceptance'),
                        sortable: true,
                    },
                    {
                        key: 'internship_agreement',
                        label: this.$t('group.internship_agreement'),
                        sortable: true,
                    },
                );
            } else {
                array.push({
                    key: 'teachers',
                    label: this.$t('group.teachers'),
                    sortable: true,
                });
            }

            array.push({
                key: 'messages',
                label: this.$t('group.unread_messages'),
                sortable: true,
            });

            if (this.groupIn.logbook) {
                array.push({
                    key: 'logbook',
                    label: this.$t('group.logbook_hours'),
                    sortable: true,
                });
            }

            if (
                this.groupIn.type_id === 1 &&
                (this.groupIn.editor_type === 'oo' || this.groupIn.editory_type === 'moo')
            ) {
                array.push({
                    key: 'words',
                    label: this.$t('group.number_of_words'),
                });
            }

            if (
                this.groupIn.type_id === 1 &&
                (this.groupIn.editor_type === 'oo' || this.groupIn.editory_type === 'moo')
            ) {
                array.push({
                    key: 'last',
                    label: this.$t('group.last_edited'),
                });
            }

            array.push({
                key: 'actions',
                label: this.$t('common.actions'),
            });

            if (this.groupIn.children.length > 0) {
                if (this.groupIn.type_id !== 2) {
                    array.splice(4, 0, {
                        key: 'sub_project',
                        label: this.$t('group.classes'),
                        sortable: true,
                    });
                } else {
                    array.splice(3, 0, {
                        key: 'sub_project',
                        label: this.$t('group.classes'),
                        sortable: true,
                    });
                }
            }

            if (this.groupIn.type_id === 6) {
                const messagesNeedle = array.map((field) => field.key).indexOf('messages');
                if (messagesNeedle !== -1) {
                    array.splice(messagesNeedle, 1);
                }

                const logbookNeedle = array.map((field) => field.key).indexOf('logbook');
                if (logbookNeedle !== -1) {
                    array.splice(logbookNeedle, 1);
                }
            }

            return array;
        },
        downloadExcelSettings() {
            if (this.groupIn.type_id === 6) {
                return [
                    {
                        name: this.$t('common.first_name'),
                        value: 'name',
                    },
                    {
                        name: this.$t('common.infix'),
                        value: 'preposition',
                    },
                    {
                        name: this.$t('common.last_name'),
                        value: 'surname',
                    },
                    {
                        name: this.$t('group.class'),
                        value: 'sub_project',
                    },
                    {
                        name: this.$t('common.organization'),
                        value: (data) => {
                            return data.internship?.organization;
                        },
                    },
                    {
                        name: this.$t('internship.name_supervisor'),
                        value: (data) => {
                            return data.internship?.supervisor;
                        },
                    },
                    {
                        name: this.$t('common.email_address'),
                        value: (data) => {
                            return data.internship?.email;
                        },
                    },
                    {
                        name: this.$t('common.phone_number'),
                        value: (data) => {
                            return `="${data.internship?.phone ?? ''}"`; // Format phone number as string in Excel
                        },
                    },
                    {
                        name: this.$t('group.internship'),
                        value: (data) => {
                            return data.internship?.name;
                        },
                    },
                    {
                        name: this.$t('common.street'),
                        value: (data) => {
                            return data.internship?.street;
                        },
                    },
                    {
                        name: this.$t('common.house_number'),
                        value: (data) => {
                            return data.internship?.streetnumber;
                        },
                    },
                    {
                        name: this.$t('common.postal_code'),
                        value: (data) => {
                            return data.internship?.zipcode;
                        },
                    },
                    {
                        name: this.$t('common.city'),
                        value: (data) => {
                            return data.internship?.location;
                        },
                    },
                    {
                        name: this.$t('group.application_status'),
                        value: (data) => {
                            if (!data.internship) {
                                return this.$t('group.not_chosen');
                            }

                            if (data.internship_project && data.internship_project.status === 2) {
                                return this.$t('group.approved');
                            }

                            return this.$t('group.wait_for_approval');
                        },
                    },
                    {
                        name: this.$t('group.motivation'),
                        value: (data) => {
                            return data.internship?.pivot.motivation;
                        },
                    },
                ];
            }

            return [];
        },

        items() {
            this.updateComputeds;
            return this.projects.map((item) => {
                let student_names = [];
                let student_prepositions = [];
                let student_surnames = [];
                let teacher_names = [];
                let subProject = '';

                for (const student of item.students) {
                    for (const user of this.studentPerProjects) {
                        if (student.id === user.id && item.id === user.project_id) {
                            subProject = user.groups.join(', ');
                        }
                    }

                    student_names.push(student.name);
                    student_prepositions.push(student.preposition);
                    student_surnames.push(student.surname);
                }

                for (const teacher of item.teachers) {
                    teacher_names.push(teacher.full_name);
                }

                let internship = null;
                let internship_project = null;
                if (item.internship_project) {
                }
                if (item.internship && item.internship !== 'undefined' && item.internship.length > 0) {
                    internship = item.internship[0];
                    if (item.signed_internship_agreements.length) {
                        internship.agreements = item.signed_internship_agreements;
                    }
                }

                return {
                    id: item.id,
                    title: item.title,
                    internship: internship,
                    name: student_names.join('\r\n'),
                    preposition: student_prepositions.join('\r\n'),
                    surname: student_surnames.join('\r\n'),
                    teachers: teacher_names.join(', '),
                    logbook: item.logbook_hours,
                    words: item.words,
                    last:
                        item.last_edited === '-'
                            ? item.last_edited
                            : this.$options.filters.date_time_om_year(item.last_edited),
                    messages_count: item.messages_count,
                    messages: item.messages,
                    sub_project: subProject,
                    internship_agreements: item.signed_internship_agreements,
                    acceptance: this.groupIn.type_id === 6 && internship ? internship.status : 0,
                    location: this.groupIn.type_id === 6 && internship ? internship.location : null,
                    internship_project:
                        this.groupIn.type_id === 6 && item.internship_project ? item.internship_project : null,
                };
            });
        },
    },

    watch: {
        internshipsIn: function (newVal) {
            this.internships = newVal;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .options {
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
    position: relative;

    .btn {
        font-size: $base-font-size;
        margin: 0;
        line-height: 1.5;

        &:before {
            margin-right: 0;
        }
    }
}

.actions {
    display: flex;
    align-items: center;

    .btn {
        font-size: 1.125rem;
    }

    .btn-remove-assignment {
        margin-left: $grid-gutter-width;
    }
}

.btn-group-student-messages,
.btn-group-student-messages-notification {
    font-size: 1.125rem;
}

.btn-group-student-messages-notification {
    position: relative;

    .group-messages-count {
        position: absolute;
        top: -13px;
        left: 7px;
    }
}

.group-assignments-accesses ::v-deep {
    .empty-assignments-list {
        .header {
            margin-bottom: map-get($grid-gutter-spacing, 'fortty-two');

            > .btn {
                width: 100%;
                text-align: center;

                &:not(:last-child) {
                    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
                }
            }
        }
    }
}

.internship-accepted {
    font-size: 1.3125rem;
}

.internship-agreement a {
    display: block;
}

.internship-accepted {
    color: $success;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .group-show-students-table ::v-deep {
        table th {
            vertical-align: top;
        }

        table tbody tr td {
            vertical-align: middle;
        }

        .apprentice-data-table-actions {
            justify-content: space-between;
            flex-wrap: wrap;

            button {
                flex: 1 0 calc(50% - 15px);
            }

            .btn-download-assignment {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }

            .btn-upload-assignment {
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
            }

            .btn-add-assignment {
                margin-top: map-get($grid-gutter-spacing, 'ten');
                flex: 0 0 calc(50% - 15px);
            }
        }
    }

    .group-assignments-accesses ::v-deep {
        .header {
            display: flex;
            flex-direction: row;

            > .btn {
                width: auto;
                text-align: left;

                &:not(:last-child) {
                    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
                    margin-right: map-get($grid-gutter-spacing, 'fifteen');
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .group-show-students-table ::v-deep {
        .apprentice-table-header {
            flex-direction: column;
        }

        .apprentice-data-table-actions {
            button {
                flex: 1 0 calc(33.333% - 15px);
            }

            .btn-download-assignment {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }

            .btn-upload-assignment {
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
            }

            .btn-add-assignment {
                margin-top: 0;
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
                flex: 0 0 calc(33.333% - 15px);
            }
        }
    }

    .group-assignments-accesses ::v-deep {
        .empty-assignments-list {
            .header {
                margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

                > button.btn {
                    width: auto;

                    &:not(:last-child) {
                        margin-bottom: 0;
                    }
                }

                .btn-assignment-import-list {
                    margin-bottom: 0;
                    flex: 1 0 auto;
                    width: auto;
                }
            }
        }
    }
}

.group-assignments-accesses ::v-deep {
    .empty-assignments-list {
        .header {
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

            > button.btn {
                width: auto;

                &:not(:last-child) {
                    margin-bottom: 0;
                }
            }

            .btn-assignment-import-list {
                margin-bottom: 0;
                flex: 1 0 auto;
                width: auto;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .group-show-students-table ::v-deep {
        .apprentice-table-header {
            flex-direction: row;
        }

        .apprentice-data-table-actions {
            button {
                flex: 0 0 auto;
            }

            .btn-add-assignment {
                flex: 0 0 auto;
            }
        }
    }
}
</style>
